import script from "./ViewMdasPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewMdasPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewMdasPage.vue?vue&type=style&index=0&id=78c6a031&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78c6a031"]])

export default __exports__